import { LoaderFunctionArgs } from "react-router";
import { IApiService } from "../../../services/ApiService";
import { handleLoaderError } from "../../../services/loaderErrorHandler";

export const editLogementPageLoader = (apiService: IApiService) => {
    return async ({ params, request }: LoaderFunctionArgs) => {
        try {
            if (!params.logementId) {
                throw new Error("Invalid id");
            }
            const logementId = parseInt(params.logementId, 10);
            if (Number.isNaN(logementId)) {
                throw new Error("Invalid id");
            }

            // Lancer tous les fetch en parallèle pour optimisation
            const [bailleurs, logement, logEntries, communes] = await Promise.all([
                apiService.getBailleurs(request.signal),
                apiService.getLogement(logementId, request.signal),
                apiService.getLogEntries(logementId, request.signal),
                apiService.getCommunes(request.signal)
            ]);

            const programme = logement.nomProgramme ?? null;

            return {
                bailleurs,
                programme,
                logement,
                logEntries,
                communes
            };
        } catch (error) {
            return handleLoaderError(error, request.url);
        }
    };
};
